// see documentation at https://developer.apple.com/library/content/featuredarticles/iPhoneURLScheme_Reference/MapLinks/MapLinks.html#//apple_ref/doc/uid/TP40007899-CH5-SW1
export const computeDirectionsUrl = (
    addressLine1: string,
    addressLine2: string,
): string =>
    `http://maps.apple.com/?daddr=${encodeURIComponent(
        addressLine1,
    )}%20${encodeURIComponent(addressLine2)}`;
